// localStorage.setItem("ageConfirmation", "false");

setTimeout(()=> { 
  const popUp = document.getElementById("boxes");
  const confirmation = localStorage.getItem("ageConfirmation")
  console.log("confirmation",confirmation)
  
  if(confirmation == "true"){
    console.log("if true")
    return;
  }
  
  console.log("if false")
  
  popUp.setAttribute('style', 'display:block !important');
  const confirmationBtn = document.getElementsByClassName("close agree")[0];
  confirmationBtn.addEventListener('click', () => {
    localStorage.setItem("ageConfirmation", "true");
  });
  
}, 3000)

